<div [formGroup]="formGroup">
  <mat-form-field>
    <input matInput [matDatepicker]="picker" formControlName="date">
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker [calendarHeaderComponent]="dayMonthHeader"></mat-datepicker>
  </mat-form-field>
</div>
